module.exports = __webpack_public_path__ + "static/img/1-1.66630c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/eng/1-1.png
// module id = n9y0
// module chunks = 0